import { buildUrl } from '@/common-utils/functions/restUtils';
import { SEARCH_CONTRACTS } from '../apiUrls';
import { client } from '@/common-utils/libraries/axios/axios';
import contractFields from '../../fields/contractFields';
import generateNestedFieldAccessor from '@/common-utils/functions/generateNestedFieldAccessor';
import getObjectAttributeFromStringKey from '@/common-utils/functions/getObjectAttributeFromStringKey';

/**
 * @param responseData
 * @param responseData.items
 * @param responseData.totalResults
 * @returns Mapped data object
 */
function mapResponseData({ items, totalResults }) {
    const data = {};

    const nestedKeyPosTerminalManufacturer = generateNestedFieldAccessor(contractFields.POS_TERMINAL.MANUFACTURER);
    const nestedKeyPosTerminalSerialNumber = generateNestedFieldAccessor(contractFields.POS_TERMINAL.SERIAL_NUMBER);

    const mappedItems = items.map(item => {
        return {
            [contractFields.UUID.key]: item[contractFields.UUID.key],
            [contractFields.APPLICATION.key]: item[contractFields.APPLICATION.key],
            [contractFields.LAST_REMOTE_COLLECTION_DATE.key]: item[contractFields.LAST_REMOTE_COLLECTION_DATE.key],
            [contractFields.NUMBER.key]: item[contractFields.NUMBER.key],
            [contractFields.BANK_CODE.key]: item[contractFields.BANK_CODE.key],
            [contractFields.RANK.key]: item[contractFields.RANK.key],
            [contractFields.LEGAL_BUSINESS_NAME.key]: item[contractFields.LEGAL_BUSINESS_NAME.key],
            [contractFields.REGISTRATION_NUMBER.key]: item[contractFields.REGISTRATION_NUMBER.key],
            [contractFields.POS_TERMINAL.key]: {
                [contractFields.POS_TERMINAL.MANUFACTURER.key]: getObjectAttributeFromStringKey(item, nestedKeyPosTerminalManufacturer),
                [contractFields.POS_TERMINAL.SERIAL_NUMBER.key]: getObjectAttributeFromStringKey(item, nestedKeyPosTerminalSerialNumber)
            },
            [contractFields.LABEL.key]: item[contractFields.LABEL.key],
            [contractFields.X25_ADDRESS.key]: item[contractFields.X25_ADDRESS.key],
            [contractFields.ITP.key]: item[contractFields.ITP.key],
            [contractFields.CB_VERSION.key]: item[contractFields.CB_VERSION.key],
            [contractFields.CREATED_AT.key]: item[contractFields.CREATED_AT.key]
        };
    });

    data.items = mappedItems;
    data.totalResults = totalResults;
    return data;
}

const queryGetContractsFromProvider = (query, enabled) => {
    return {
        queryKey: [SEARCH_CONTRACTS.DIRECT_PROVIDER_COLLECTION.queryKey, query],
        queryFn: async () => {
            const response = await client.get(buildUrl(SEARCH_CONTRACTS.DIRECT_PROVIDER_COLLECTION.url, query));
            return mapResponseData(response.data);
        },
        enabled: enabled
    };
};

export default queryGetContractsFromProvider;